// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"717221ca","356":"717221ca","2985":"717221ca","4905":"717221ca"}[chunkId] + ".chunk.css";
};